import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Flex, Form, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { useWatermarkValue } from 'context';
import { updateWatermark } from 'services';
import { PATHNAME } from 'utils';

import { WatermarkFormAction } from './action';
import { WatermarkFormContent } from './content';

const {
  LOCAL: {
    HOME: { BASE_URL: HOME_BASE_URL },
  },
} = PATHNAME;

type FieldType = ReturnType<typeof useWatermarkValue>;

const WatermarkForm = () => {
  const [form] = Form.useForm<FieldType>();
  const {
    imageId,
    opacity,
    minWidth,
    width,
    maxWidth,
    minHeight,
    height,
    maxHeight,
    top,
    right,
    bottom,
    left,
  } = useWatermarkValue();
  const navigate = useNavigate();

  const onFinish = useLockFn(async (field: FieldType) => {
    const body: Parameters<typeof updateWatermark>[0] = {
      imageId,
      opacity,
      minWidth,
      width,
      maxWidth,
      minHeight,
      height,
      maxHeight,
      top,
      right,
      bottom,
      left,
    };

    return updateWatermark(body)
      .then(() => {
        notification.success({
          message: `نهان‌نگاری با موفقیت ویرایش شد.`,
        });
        navigate(HOME_BASE_URL);
      })
      .catch(message => {
        notification.error({ message });
      });
  });

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Flex
        className='*:rounded *:bg-white max-xl:flex-col max-xl:last:*:sticky max-xl:last:*:inset-x-0 max-xl:last:*:bottom-0 max-xl:last:*:z-10 max-xl:last:*:shadow-inner xl:items-start xl:first:*:basis-[70%] xl:last:*:basis-[30%]'
        gap='large'
      >
        <WatermarkFormContent />
        <WatermarkFormAction />
      </Flex>
    </PrimitiveForm>
  );
};

export { WatermarkForm };
